
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/library",
      function () {
        return require("private-next-pages/student/library/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/library"])
      });
    }
  